import { GmailAppRow } from '../components/GmailAppRow';
import type { AppRow } from '../type/AppRow';

export const gmailAppRow: AppRow = {
  key: 'gmail',
  name: 'Gmail',
  AppComponent: GmailAppRow,
};
